import { navLinks } from "../NavBar/NavBar.controller";

export const footerLinks = navLinks;

export const footerNote = "Building experiences people remember.";
